import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b61a0f42"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "widget-title__head"
}
const _hoisted_2 = {
  key: 0,
  class: "widget-title__name"
}
const _hoisted_3 = {
  key: 1,
  class: "widget-title__name"
}
const _hoisted_4 = { class: "widget-title__button" }

import { ElButton } from 'element-plus'
import { computed, useSlots } from 'vue'

type ButtonType = typeof ElButton

interface Props {
  show?: boolean
  title?: string
  height?: string
  actions?: ButtonType[]
}


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'WidgetTitle' },
  __name: 'widget-title',
  props: {
    show: { type: Boolean, default: true },
    title: {},
    height: { default: '100%' },
    actions: {}
  },
  setup(__props: any) {

const slots = useSlots()

const titleSlot = computed(() => Boolean(slots.title))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "widget-title",
    style: _normalizeStyle({ height: _ctx.height })
  }, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (titleSlot.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "title")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("em", null, _toDisplayString(_ctx.title), 1)
              ])),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (item, index) => {
              return (_openBlock(), _createBlock(_unref(ElButton), {
                key: index,
                type: item.type || 'primary',
                size: item.size || 'large',
                plain: item.plain,
                onClick: ($event: any) => (_ctx.$emit(item.emit, item))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["type", "size", "plain", "onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})